export class Usuario{
    id: number;
    login: string;
    nome: string;
    isAdmin: boolean;
    token:string;
    username:string;
    password: string;
}